var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyOrders = function SvgMyOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.167 5h11.666c.46 0 .834.374.834.833H3.333c0-.46.374-.833.834-.833M14.583 11.667a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.667 7.5c.46 0 .833.374.833.833V15c0 .46-.374.833-.833.833H3.333A.834.834 0 0 1 2.5 15V8.333c0-.46.374-.833.833-.833zm0-.833H3.333c-.92 0-1.666.747-1.666 1.666V15c0 .92.747 1.667 1.666 1.667h13.334c.92 0 1.666-.748 1.666-1.667V8.333c0-.92-.747-1.666-1.666-1.666M5.833 3.333h8.334c.46 0 .833.374.833.834H5c0-.46.374-.834.833-.834"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 9.167H4.167V10H12.5zM10.833 10.833H4.167v.834h6.666z"
  })));
};
export default SvgMyOrders;